module.exports = __webpack_public_path__ + "static/media/land.b2e36040.svg";